var exports = {
  "zr": "x0a7806d5--1edd2a--root",
  "fW": "x0a7806d5--1edd2a--with-ellipsis",
  "yC": "x0a7806d5--1edd2a--with-counter",
  "vu": "x0a7806d5--1edd2a--active",
  "hJ": "x0a7806d5--1edd2a--counter",
};

module.exports = exports;
